import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgkc008aRequest, Sgkc008aResponse, SGKC008AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * 単価表登録API使用サービス
 * @export
 * @class UsedSgkc008aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc008aService {
    /**
       * コンストラクタ
       * @param {SGKC008AService} sGKC008AService
       * @param {ApiCommonService} apiCommonService
       * @param {TimeApiService} timeApiService
       * @param {FeaturesLibConfig} featuresLibConfig
       * @memberof UsedSgkc008aService
       */
    constructor(private sGKC008AService: SGKC008AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * 単価表登録API呼び出し
     * @param {Sgkc008aRequest} sgkc008aRequest
     * @return {Observable<Sgkc008aResponse>}
     * @memberof UsedSgkc008aService
     */
    registTankatable(sgkc008aRequest: Sgkc008aRequest): Observable<Sgkc008aResponse> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(sgkc008aRequest, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

        return this.sGKC008AService.kC10WSGKC008APost(<Sgkc008aRequest>this.apiCommonService.setRequestCommon(sgkc008aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC008A');
                    return throwError(err.message);
                })
            );
    }

}
